import React from "react";
import { useGetCorporateTouchPointsQuery } from "../../../../redux/service/modules/dashboard";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    ResponsiveContainer,
    Cell,
    CartesianGrid,
    LabelList,
} from "recharts";
import { useSelector } from "react-redux";
import Loader from "../../../../components/common/loader";
import { COLORS } from "../../../../utils/constant";
import NoDataAvailable from "../../../../components/common/NoDataAvailable";
import TableLayout from "../../../../components/layout/TableLayout";

// Transform function to convert object to array of objects and assign colors
const transformData = (data) => {
    return Object.entries(data).map(([name, value], index) => ({
        name,
        value,
        color: COLORS[index % COLORS.length], // Assign color based on index
    }));
};
const CustomLegend = ({ payload }) => {
    return (
        <div
            style={{
                marginLeft: "3.5rem",
                display: "flex",
                flexWrap: "wrap",
                width: "80%",
            }}
            className="mt-8"
        >
            {payload.map((entry, index) => (
                <div
                    key={`item-${index}`}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "5px 0",
                        width: "20%",
                    }}
                >
                    <div
                        style={{
                            width: "12px",
                            height: "12px",
                            backgroundColor: entry.color,
                            marginRight: "8px",
                            borderRadius: "2px",
                        }}
                    />
                    <span style={{ textAlign: "center" }}>
                        {entry.name.charAt(0).toUpperCase() +
                            entry.name.slice(1)}
                    </span>
                </div>
            ))}
        </div>
    );
};

export const TouchPoints = () => {
    const dateRange = useSelector((state) => state.date);
    const { data, isLoading, error } =
        useGetCorporateTouchPointsQuery(dateRange);

    // Transform the data if it exists
    const chartData = data ? transformData(data) : [];

    let staticContent;
    if (isLoading) {
        staticContent = <Loader />;
    } else if (error) {
        staticContent = "Error";
    } else if (Object.keys(data).length === 0) {
        staticContent = <NoDataAvailable />;
    }

    return (
        <TableLayout>
            {staticContent ? (
                <div style={styles.staticContent}>{staticContent}</div>
            ) : (
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        data={chartData}
                        barSize={100}
                        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                    >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <XAxis dataKey="name" hide />
                        <YAxis />
                        <Tooltip cursor={{ fill: "transparent" }} />
                        <Legend
                            content={<CustomLegend />}
                            payload={chartData}
                        />
                        <Bar dataKey="value" radius={[6, 6, 0, 0]}>
                            {chartData.map((entry, index) => (
                                <Cell
                                    key={`cell-${index}`}
                                    fill={entry.color}
                                />
                            ))}
                            <LabelList
                                dataKey="value"
                                position="top"
                                fill="black"
                                offset={10}
                            />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            )}
        </TableLayout>
    );
};

const styles = {
    staticContent: {
        height: "80%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
};
